<template>
    <div class="view-wrap">
        <div class="view-wrap-item" v-for="(item, index) in list" :key="index">
            <div class="wrap-item-body">
                <div class="wrap-item-left" @click="$router.push('/goodsDetail/'+item.productId)">
                    <img :src=" getFirstImg(item.productImage) " alt="">
                    <p class="item-left-type"
                        :class="{
                            'item-left-type-red': item.businessProperty == 2,
                            'item-left-type-blue': item.businessProperty == 3,
                            'item-left-type-yellow': item.businessProperty == 4
                        }"
                    >{{ propertyFilter(item.businessProperty) }}</p>
                </div>
                <div class="wrap-item-right">
                    <div>
                        <p class="item-right-title">{{ item.productName }}</p>
                        <div class="item-right-subTitle">
                            <span>已售{{ item.productSalesNumber }}</span>
                            <span>剩余{{ item.productNum }}</span>
                        </div>
                        <p class="item-right-price" v-if="item.businessProperty != 2&&item.isOpenCredit==1">￥{{ item.creditProductPrice || 0 }}+{{ item.needCredit || 0 }}积分</p>
                    </div>
                    <div class="item-right-ft">
                        <div>
                            <div class="right-ft-handle">
                                <div class="ft-handle-left">
                                    <span class="handle-left-unit">￥</span>
                                    <span class="handle-left-price">{{ priceFilter(item.productPreferentialPrice, 0) }}</span>
                                    <span class="handle-left-price-small">.{{ priceFilter(item.productPreferentialPrice, 1) }}</span>
                                </div>
                                <div class="ft-handle-right">
                                    <img src="~img/home/add.png" @click="handleNum(item.productId, 1)" alt="">
                                </div>
                            </div>
                        </div>
                        <p class="right-ft-oldPrice">￥{{ item.productPrice }}</p>
                    </div>
                </div>
            </div>
            <div class="wrap-item-shop" v-if="item.businessProperty != 3">
                <span class="item-shop-name">{{ item.productBusinessName }}</span>
                <span class="item-shop-link">进店&nbsp;></span>
            </div>
        </div>
		<common-empty v-if="list.length==0" class="commonEmpty" text="找不到该商品" />
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import Cart from '@/config/shopCart';
import baseUrl from '@/config/baseUrl';
export default {
    props: {
        list: Array
    },
    mixins: [Cart],
    data() {
        return {
            baseUrl
        };
    },
    methods: {
        propertyFilter(value) {
            switch (value) {
            case 2:
                return '缤纷精选';
            case 3:
                return '物业自营';
            case 4:
                return '周边商家';
            default:
                return '';
            }
        },
        priceFilter(value, index) {
            if(!value || isNaN(value)) {
                return 0;
            }
            value = String(value);
            let arr = value.split('.');
            return arr[index] ? arr[index] : 0;
        },
        getFirstImg(s) {
            let arr = s.split(',');
            return arr.length ? baseUrl.imgUrl + arr[0] : '';
        },
        handleNum(id, type){
            this.updateCart({
                productId: id,
                productNum: type
            }).then((res) => {
                this.$toast(res.msg);
            }).catch((res) => {
                this.$toast(res.error);
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.view-wrap {
    flex: 1;
    overflow-y: auto;
    padding: 11px 8px;

    .view-wrap-item {
        border-radius: 3px;
        background-color: #FFFFFF;
        padding: 10px;
        margin-bottom: 9px;

        .wrap-item-body {
            display: flex;
            justify-content: space-between;

            .wrap-item-left {
                position: relative;
                width: 140px;
                height: 140px;
                margin-right: 16px;

                img {
                    width: 100%;
                    height: 100%;
                }
                .item-left-type {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 38px;
                    padding: 6px;
                    box-sizing: border-box;
                    text-align: center;
                    background-color: #2D95FE;
                    font-size: 12px;
                    font-weight: bold;
                    line-height: 13px;
                    color: #FFFFFF;
                }
                .item-left-type-blue {
                    background-color: #2D95FE;
                }
                .item-left-type-yellow {
                    background-color: #ED863F;
                }
                .item-left-type-red {
                    background-color: #CA3D35;
                }
            }
            .wrap-item-right {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                min-width: 0;

                .item-right-title {
                    color: #000000;
                    font-size: 15px;
                    font-weight: bold;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .item-right-subTitle {
                    font-size: 12px;
                    color: #A3A3A3;
                    margin-top: 10px;
                    line-height: 12px;

                    span {
                        margin-right: 20px;
                    }
                }
                .item-right-price {
                    font-size: 15px;
                    font-weight: bold;
                    color: #E85B4D;
                    margin-top: 13px;
                }
                .item-right-ft {

                    .right-ft-handle {
                        display: flex;
                        justify-content: space-between;

                        .ft-handle-left {
                            color: #E85B4D;
                            font-weight: bold;
                            height: 25px;
                            line-height: 25px;

                            .handle-left-unit {
                                font-size: 15px;
                            }
                            .handle-left-price {
                                font-size: 24px;
                            }
                            .handle-left-price-small {
                                font-size: 12px;
                            }
                        }
                        .ft-handle-right {
                            font-size: 0;

                            img {
                                width: 25px;
                            }
                        }
                    }
                    .right-ft-oldPrice {
                        font-size: 12px;
                        color: #B2B0B0;
                        text-decoration: line-through;
                    }
                }
            }
        }
        .wrap-item-shop {
            margin-top: 10px;
            font-size: 10px;

            .item-shop-name {
                color: #6B6B6B;
                margin-right: 20px;
            }
            .item-shop-link {
                color: #000000;
            }
        }
    }
}
</style>